import React, { useState } from 'react';
import {
    Box,
    Typography,
    Button
} from '@mui/material';
import {
    Image as ImageIcon,
    InsertDriveFile as FileIcon,
    VideoFile as VideoIcon,
    AudioFile as AudioIcon,
    BrokenImage as BrokenImageIcon
} from '@mui/icons-material';

const MediaPreview = ({ message }) => {
    const [imageError, setImageError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const handleImageError = () => {
        console.error('Failed to load image:', message.file_url);
        setImageError(true);
        setIsLoading(false);
    };

    const handleImageLoad = () => {
        setIsLoading(false);
    };

    const getFileIcon = (type) => {
        switch (type) {
            case 'image':
                return <ImageIcon sx={{ fontSize: 40, color: 'primary.main' }} />;
            case 'video':
                return <VideoIcon sx={{ fontSize: 40, color: 'primary.main' }} />;
            case 'audio':
                return <AudioIcon sx={{ fontSize: 40, color: 'primary.main' }} />;
            default:
                return <FileIcon sx={{ fontSize: 40, color: 'primary.main' }} />;
        }
    };

    // Для картинок показываем превью если нет ошибки загрузки
    if (message.type === 'image' && !imageError && message.file_url) {
        return (
            <Box sx={{ mb: 1, position: 'relative' }}>
                {isLoading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(0,0,0,0.1)',
                        borderRadius: 1
                    }}>
                        <Typography variant="caption" color="text.secondary">
                            Loading...
                        </Typography>
                    </Box>
                )}
                <img
                    src={message.file_url}
                    alt="Image"
                    style={{
                        maxWidth: '100%',
                        borderRadius: 4,
                        display: isLoading ? 'none' : 'block'
                    }}
                    onError={handleImageError}
                    onLoad={handleImageLoad}
                />
            </Box>
        );
    }

    // Заглушка для файлов или сломанных картинок
    return (
        <Box sx={{
            mb: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 2,
            border: '1px dashed',
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: 'background.default'
        }}>
            {imageError ? (
                <BrokenImageIcon sx={{ fontSize: 40, color: 'error.main', mb: 1 }} />
            ) : (
                getFileIcon(message.type)
            )}
            <Typography variant="body2" color="text.secondary" align="center">
                {imageError ? 'Failed to load image' : 'File attachment'}
            </Typography>
            {message.file_url && !message.isTemporary && (
                <Button
                    variant="outlined"
                    size="small"
                    href={message.file_url}
                    target="_blank"
                    sx={{ mt: 1 }}
                >
                    Open File
                </Button>
            )}
        </Box>
    );
};

export default MediaPreview;